import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SiteState } from 'src/app/shared/models';

import * as CopyCropFieldsToManureSpaceSelectors from '../../store/copy-cropfields-to-manure-space.selectors';

@Component({
  selector: 'app-copy-cropfields-to-manure-space-progress',
  templateUrl: './copy-cropfields-to-manure-space-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyCropFieldsToManureSpaceProgressComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  percentage$ = this.store.pipe(select(CopyCropFieldsToManureSpaceSelectors.selectCopyPercentage));
  copying$ = this.store.pipe(select(CopyCropFieldsToManureSpaceSelectors.selectAmountCopying));
  completed$ = this.store.pipe(select(CopyCropFieldsToManureSpaceSelectors.selectAmountCompleted));
}
